module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-multi-select",
    class: {
      'is-disabled': _vm.disabled, 'is-show': _vm.show
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        !_vm.disabled && (_vm.show = !_vm.show)
      }
    }
  }, [_c('div', {
    staticClass: "select-mark"
  }, [_c('vbl-icon', {
    attrs: {
      "type": "ion-arrow-down-b"
    }
  })], 1), _c('div', {
    staticClass: "selected"
  }, [(!_vm.selected.length) ? _c('span', {
    staticClass: "selected-placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), (_vm.selected.length) ? _c('div', {
    staticClass: "selected-items"
  }, _vm._l((_vm.selected), function(item) {
    return _c('span', {
      staticClass: "selected-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('vbl-icon', {
      attrs: {
        "type": "ion-ios-close-empty",
        "size": "18"
      },
      on: {
        "click": function($event) {
          _vm.close(item)
        }
      }
    }), _vm._v("\n                    " + _vm._s(item.$el.innerText) + "\n                ")], 1)
  })) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "list"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459db5fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblSelect/src/vblMultiSelect.vue
// module id = 260
// module chunks = 0